<div class="dialog-backdrop" (click)="cancelled.emit()">
  <section
    class="regeneration-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="edi-regeneration-title"
    (click)="$event.stopPropagation()"
  >
    <header>
      <div>
        <span class="eyebrow">AI view guidance</span>
        <h4 id="edi-regeneration-title">Regenerate document view</h4>
      </div>
      <button type="button" class="close-button" aria-label="Close" (click)="cancelled.emit()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <p>
      Optionally describe how fields, columns, sections, or package contents should be arranged. Source values and
      bindings remain authoritative.
    </p>

    <label for="edi-regeneration-instruction">Layout instruction</label>
    <textarea
      id="edi-regeneration-instruction"
      class="form-control"
      rows="5"
      maxlength="1000"
      [(ngModel)]="instruction"
      placeholder="Example: Group DESADV products under each package and show SSCC in the package heading."
    ></textarea>
    <small class="character-count">{{ instruction.length }} / {{ maxInstructionLength }}</small>

    <label class="persist-option" [class.disabled]="!instruction.trim()">
      <input type="checkbox" [(ngModel)]="persistInstruction" [disabled]="!instruction.trim()" />
      <span>
        <strong>Apply to future generated views</strong>
        <small>Save this guidance for the same EDI configuration and document context.</small>
      </span>
    </label>

    <footer>
      <button type="button" class="btn btn-outline-secondary" (click)="cancelled.emit()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="confirm()">
        <i class="fa-solid fa-wand-magic-sparkles mr-1"></i>
        Regenerate
      </button>
    </footer>
  </section>
</div>
